import config from 'config';
import tmpl from './view.phtml';
import View from 'lib/View';
// import Img from 'view/img';

export default View.extend({
	template: tmpl,

	events: {
		'click button[data-pond-status]': 'setPondStatus'
	},

	initialize: function()
	{
		var render = _.debounce( this.render, 100 )
		this.listenTo( this.model, 'all', render );
	},

	setPondStatus: function( evt )
	{
		evt.preventDefault();

		this.model.set('status',$(evt.target).data('pond-status'));
		this.model.set('todo','update');
		app.persistModel( this.model ).then( function()
		{
			app.commit();
		} );
	},

	render: function()
	{
		this.doRender({
			pond: this.model,
			zone: this.model.getZone(),
			image_list: this.model.getImageList(),
// 			visit_list: this.model.getVisitList()
		});

		_.invoke( this.model.getImageList(), 'loadSrc' );
	}
});
